export const MODAL_HEIGHT_CSS_VAR = '--ribbons-modal-viewport-height';
